module.exports = __webpack_public_path__ + "img/auxano-web.4e4da39e.webp";